<template>
  <div class="real-auth page">
    <van-nav-bar :title="text.title" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template>
    </van-nav-bar>

    <div class="real-auth-content">
      <div class="auth-card">
        <div class="auth-header">
          <div>
            <div class="auth-title">{{ text.title }}</div>
            <div class="auth-subtitle">{{ text.subtitle }}</div>
          </div>
          <van-icon name="certificate" />
        </div>

        <van-cell-group class="auth-form">
          <van-field
            v-model="realName"
            :label="text.realName"
            :placeholder="text.realNamePlaceholder"
            :readonly="isLocked"
          />
          <van-field
            v-model="idCard"
            :label="text.idCard"
            :placeholder="text.idCardPlaceholder"
            :readonly="isLocked"
          />
        </van-cell-group>
      </div>

      <div class="upload-card">
        <div class="section-title">{{ text.photoTitle }}</div>
        <div class="upload-grid">
          <div class="upload-item">
            <div class="upload-label">{{ text.frontLabel }}</div>
            <van-uploader
              v-model="frontFileList"
              :after-read="file => uploadImage(file, 'front')"
              :max-count="1"
              :deletable="canSubmit"
              :disabled="isLocked"
              accept="image/*"
            >
              <div class="upload-box">
                <van-loading v-if="frontUploading" size="24px" color="#fff" />
                <template v-else>
                  <van-icon name="photograph" />
                  <span>{{ text.uploadFront }}</span>
                </template>
              </div>
            </van-uploader>
          </div>

          <div class="upload-item">
            <div class="upload-label">{{ text.backLabel }}</div>
            <van-uploader
              v-model="backFileList"
              :after-read="file => uploadImage(file, 'back')"
              :max-count="1"
              :deletable="canSubmit"
              :disabled="isLocked"
              accept="image/*"
            >
              <div class="upload-box">
                <van-loading v-if="backUploading" size="24px" color="#fff" />
                <template v-else>
                  <van-icon name="photograph" />
                  <span>{{ text.uploadBack }}</span>
                </template>
              </div>
            </van-uploader>
          </div>
        </div>
      </div>

      <div class="auth-status" v-if="isLocked">
        <van-icon :name="realStatus === 'approved' ? 'checked' : 'clock-o'" />
        <span>{{ statusText }}</span>
      </div>

      <div class="auth-reject" v-if="realStatus === 'rejected' && rejectReason">
        <van-icon name="warning-o" />
        <span>{{ rejectReason }}</span>
      </div>

      <van-button
        v-if="canSubmit"
        class="submit-btn"
        type="default"
        :loading="loading"
        :loading-text="text.submitting"
        block
        @click="submitAuth()"
      >
        {{ text.submit }}
      </van-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      realName: '',
      idCard: '',
      frontImage: '',
      backImage: '',
      frontFileList: [],
      backFileList: [],
      frontUploading: false,
      backUploading: false,
      loading: false,
      userInfo: {},
      text: {
        title: '\u5b9e\u540d\u8ba4\u8bc1',
        subtitle: '\u8bf7\u586b\u5199\u672c\u4eba\u4fe1\u606f\u5e76\u4e0a\u4f20\u8eab\u4efd\u8bc1\u6b63\u53cd\u9762',
        realName: '\u771f\u5b9e\u59d3\u540d',
        realNamePlaceholder: '\u8bf7\u8f93\u5165\u771f\u5b9e\u59d3\u540d',
        idCard: '\u8eab\u4efd\u8bc1\u53f7',
        idCardPlaceholder: '\u8bf7\u8f93\u5165\u8eab\u4efd\u8bc1\u53f7',
        photoTitle: '\u8bc1\u4ef6\u7167\u7247',
        frontLabel: '\u8eab\u4efd\u8bc1\u6b63\u9762',
        backLabel: '\u8eab\u4efd\u8bc1\u53cd\u9762',
        uploadFront: '\u4e0a\u4f20\u6b63\u9762',
        uploadBack: '\u4e0a\u4f20\u53cd\u9762',
        authed: '\u5df2\u5b8c\u6210\u5b9e\u540d\u8ba4\u8bc1',
        submitting: '\u63d0\u4ea4\u4e2d...',
        submit: '\u63d0\u4ea4\u8ba4\u8bc1'
      }
    };
  },
  computed: {
    hasSubmittedData() {
      return !!(this.realName || this.idCard || this.frontImage || this.backImage);
    },
    statusValue() {
      return this.userInfo.real_status !== undefined ? this.userInfo.real_status
        : this.userInfo.auth_status !== undefined ? this.userInfo.auth_status
          : this.userInfo.is_real !== undefined ? this.userInfo.is_real
            : this.userInfo.status;
    },
    statusLabel() {
      return String(this.userInfo.status_text || this.userInfo.status_name || this.userInfo.audit_status_text || this.userInfo.msg || '').toLowerCase();
    },
    realStatus() {
      const value = this.statusValue;
      const label = this.statusLabel;

      if (label.indexOf('拒') !== -1 || label.indexOf('驳') !== -1 || label.indexOf('fail') !== -1 || label.indexOf('reject') !== -1) {
        return 'rejected';
      }
      if (label.indexOf('通过') !== -1 || label.indexOf('成功') !== -1 || label.indexOf('approved') !== -1 || label.indexOf('pass') !== -1) {
        return 'approved';
      }
      if (label.indexOf('审核') !== -1 || label.indexOf('待审') !== -1 || label.indexOf('提交') !== -1 || label.indexOf('pending') !== -1 || label.indexOf('review') !== -1) {
        return 'pending';
      }

      if (value === 1 || value === '1' || value === true) {
        return 'approved';
      }
      if (value === -1 || value === '-1' || value === 3 || value === '3') {
        return 'rejected';
      }
      if (value === 2 || value === '2') {
        return this.userInfo.reject_reason || this.userInfo.reason ? 'rejected' : 'pending';
      }
      if ((value === 0 || value === '0') && this.hasSubmittedData) {
        return 'pending';
      }

      return 'not_submitted';
    },
    canSubmit() {
      return this.realStatus === 'not_submitted' || this.realStatus === 'rejected';
    },
    isLocked() {
      return this.realStatus === 'pending' || this.realStatus === 'approved';
    },
    statusText() {
      if (this.realStatus === 'approved') {
        return '实名认证已通过';
      }
      if (this.realStatus === 'pending') {
        return '实名认证审核中';
      }
      return '';
    },
    rejectReason() {
      return this.userInfo.reject_reason || this.userInfo.reason || this.userInfo.audit_remark || this.userInfo.remark || '';
    }
  },
  methods: {
    back() {
      this.$router.push({ path: '/Mine' });
    },
    formatImageUrl(url) {
      if (!url) {
        return '';
      }
      if (/^(https?:)?\/\//.test(url) || /^data:image\//.test(url) || /^blob:/.test(url)) {
        return url;
      }
      const path = url.charAt(0) === '/' ? url : '/' + url;
      return 'https://api.dpyzcoin.com' + path;
    },
    setUploadImage(type, url, preview) {
      const previewUrl = preview || this.formatImageUrl(url);
      const fileItem = previewUrl ? {
        url: previewUrl,
        content: previewUrl,
        isImage: true
      } : null;
      if (type === 'front') {
        this.frontImage = url;
        this.frontFileList = fileItem ? [fileItem] : [];
      } else {
        this.backImage = url;
        this.backFileList = fileItem ? [fileItem] : [];
      }
    },
    uploadImage(file, type) {
      if (!file || !file.file) {
        this.$toast.fail('\u8bf7\u9009\u62e9\u56fe\u7247');
        return;
      }

      const formData = new FormData();
      formData.append('file', file.file);
      this.setUploadLoading(type, true);

      this.$http({
        method: 'post',
        url: 'realname_upload',
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        this.setUploadLoading(type, false);
        if (res.code === 200) {
          const url = res.data;
          this.setUploadImage(type, url, file.content);
          this.$toast(res.msg || '\u4e0a\u4f20\u6210\u529f');
        } else {
          this.clearUpload(type);
          this.$toast(res.msg || '\u4e0a\u4f20\u5931\u8d25');
        }
      }).catch(() => {
        this.setUploadLoading(type, false);
        this.clearUpload(type);
        this.$toast.fail('\u4e0a\u4f20\u5931\u8d25\uff0c\u8bf7\u91cd\u8bd5');
      });
    },
    setUploadLoading(type, value) {
      if (type === 'front') {
        this.frontUploading = value;
      } else {
        this.backUploading = value;
      }
    },
    clearUpload(type) {
      if (type === 'front') {
        this.frontImage = '';
        this.frontFileList = [];
      } else {
        this.backImage = '';
        this.backFileList = [];
      }
    },
    firstValue(sources, keys) {
      for (let i = 0; i < sources.length; i++) {
        const source = sources[i];
        if (!source) {
          continue;
        }
        for (let j = 0; j < keys.length; j++) {
          const value = source[keys[j]];
          if (value !== undefined && value !== null && value !== '') {
            return value;
          }
        }
      }
      return '';
    },
    normalizeStatusData(data) {
      const sources = [
        data,
        data.info,
        data.detail,
        data.realname,
        data.real_name_info,
        data.auth,
        data.auth_info,
        data.user,
        data.member
      ];
      const merged = Object.assign({}, ...sources.filter(Boolean));

      return {
        statusInfo: merged,
        realName: this.firstValue(sources, ['real_name', 'realname', 'name', 'true_name', 'username']),
        idCard: this.firstValue(sources, ['id_card', 'idcard', 'card_no', 'card_number', 'id_number', 'identity_no']),
        frontImage: this.firstValue(sources, ['id_card_front', 'card_front', 'front_image', 'front_img', 'front', 'idcard_front', 'image_front']),
        backImage: this.firstValue(sources, ['id_card_back', 'card_back', 'back_image', 'back_img', 'back', 'idcard_back', 'image_back'])
      };
    },
    submitAuth() {
      if (!this.realName) {
        this.$toast.fail('\u8bf7\u8f93\u5165\u771f\u5b9e\u59d3\u540d');
        return;
      }
      if (!this.idCard) {
        this.$toast.fail('\u8bf7\u8f93\u5165\u8eab\u4efd\u8bc1\u53f7');
        return;
      }
      if (!this.frontImage) {
        this.$toast.fail('\u8bf7\u4e0a\u4f20\u8eab\u4efd\u8bc1\u6b63\u9762');
        return;
      }
      if (!this.backImage) {
        this.$toast.fail('\u8bf7\u4e0a\u4f20\u8eab\u4efd\u8bc1\u53cd\u9762');
        return;
      }

      this.loading = true;
      this.$http({
        method: 'post',
        data: {
          real_name: this.realName,
          name: this.realName,
          id_card: this.idCard,
          card_no: this.idCard,
          id_card_front: this.frontImage,
          id_card_back: this.backImage,
          card_front: this.frontImage,
          card_back: this.backImage
        },
        url: 'realname_submit'
      }).then(res => {
        this.loading = false;
        if (res.code === 200) {
          this.$toast(res.msg || '\u8ba4\u8bc1\u63d0\u4ea4\u6210\u529f');
          this.getUserInfo();
        } else {
          this.$toast(res.msg || '\u8ba4\u8bc1\u63d0\u4ea4\u5931\u8d25');
        }
      }).catch(() => {
        this.loading = false;
        this.$toast.fail('\u8ba4\u8bc1\u63d0\u4ea4\u5931\u8d25');
      });
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'realname_status'
      }).then(res => {
        if (res.code === 200) {
          const normalized = this.normalizeStatusData(res.data || {});
          this.userInfo = normalized.statusInfo;
          this.realName = normalized.realName;
          this.idCard = normalized.idCard;
          this.frontImage = normalized.frontImage;
          this.backImage = normalized.backImage;
          this.setUploadImage('front', this.frontImage);
          this.setUploadImage('back', this.backImage);
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' });
    } else {
      this.getUserInfo();
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";

.real-auth {
  min-height: 100vh;
  background: #29243d;
}

.real-auth-content {
  padding: 24px;
}

.auth-card,
.upload-card {
  overflow: hidden;
  margin-bottom: 24px;
  border-radius: 12px;
  background: #342f46;
}

.auth-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 34px 28px 30px;
  color: #fff;
  background: linear-gradient(135deg, #4a3a68 0%, #342f46 100%);
}

.auth-header .van-icon {
  font-size: 58px;
  color: #ff68d8;
}

.auth-title {
  font-size: 34px;
  font-weight: 700;
}

.auth-subtitle {
  margin-top: 12px;
  color: rgba(255, 255, 255, .68);
  font-size: 24px;
  line-height: 38px;
}

::v-deep .auth-form {
  padding: 18px 24px 24px;
}

.section-title {
  padding: 24px 24px 0;
  color: #fff;
  font-size: 30px;
  font-weight: 700;
}

.upload-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 18px;
  padding: 24px;
}

.upload-label {
  margin-bottom: 12px;
  color: rgba(255, 255, 255, .82);
  font-size: 24px;
}

.upload-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 170px;
  border: 1px dashed rgba(255, 104, 216, .65);
  border-radius: 10px;
  color: #fff;
  background: rgba(255, 255, 255, .05);
  box-sizing: border-box;
}

.upload-box .van-icon {
  margin-bottom: 12px;
  font-size: 46px;
  color: #ff68d8;
}

.upload-box span {
  font-size: 24px;
}

.submit-btn {
  height: 88px;
  margin-top: 34px;
  border: 0;
  border-radius: 10px;
  color: #fff;
  background: #e63fbc;
  font-size: 30px;
}

.auth-status {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  height: 88px;
  margin-top: 34px;
  border-radius: 10px;
  color: #fff;
  background: #342f46;
  font-size: 30px;
}

.auth-reject {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-top: 20px;
  padding: 18px 20px;
  border-radius: 10px;
  color: #ffdce8;
  background: rgba(230, 63, 188, .16);
  font-size: 24px;
  line-height: 1.5;
}

.auth-reject .van-icon {
  flex: 0 0 auto;
  margin-top: 4px;
  color: #ff68d8;
  font-size: 28px;
}

::v-deep .van-cell-group {
  background: #342f46;
}

::v-deep .van-cell {
  display: flex;
  align-items: center;
  min-height: 74px;
  padding: 16px 0;
  color: #fff;
  background: #342f46;
  font-size: 28px;
}

::v-deep .van-cell::after {
  border-color: rgba(255, 255, 255, .08);
}

::v-deep .van-field__label {
  width: 150px;
  margin-right: 24px;
  color: rgba(255, 255, 255, .86);
  font-weight: 600;
  line-height: 42px;
}

::v-deep .van-field__control {
  color: #fff;
  line-height: 42px;
}

::v-deep .van-field__control::placeholder {
  color: rgba(255, 255, 255, .45);
}

::v-deep .van-uploader {
  width: 100%;
}

::v-deep .van-uploader__wrapper,
::v-deep .van-uploader__input-wrapper {
  width: 100%;
}

::v-deep .van-uploader__preview,
::v-deep .van-uploader__preview-image,
::v-deep .van-uploader__file {
  width: 100%;
  height: 170px;
  margin: 0;
  border-radius: 10px;
  overflow: hidden;
}

::v-deep .van-uploader__preview-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

@media (max-width: 360px) {
  .upload-grid {
    grid-template-columns: 1fr;
  }
}
</style>
